import { Component, Input } from '@angular/core';


@Component({
    selector: 'unit-detail',
    templateUrl: './unit-detail.component.html',
    styleUrls: ['./unit-detail.component.scss']
})
export class UnitDetailComponent {

    @Input() info : any;
    @Input() selected : any = {};
    @Input() condition : any = null;
    @Input() unique : boolean = false;

    constructor( 
    ){
    }

}